import { data } from 'autoprefixer';
import { usePredictContext } from '../../context/PredictContextProvider';
import { lazy, useMemo } from 'react';

const TechV6Scenarios = lazy(() => import('./TechV6Scenarios'))
const TechV7_2Scenarios = lazy(() => import('./TechV7.2Scenarios'))
const TechScenarios = lazy(() => import('./TechScenarios'))

const scenarioRegistry = {
    'technical-market-analysis': TechScenarios,
    'technical-market-analysis-v6': TechV6Scenarios,
    'technical-market-analysis-v7.2': TechV7_2Scenarios
}

const ScenariosTab = ({ advance }) => {

    const { assistant } = usePredictContext()
    const { value } = assistant.assistant

    const shouldRenderScenarios = useMemo(() => {
        const includedValues = ['technical-market-analysis', 'technical-market-analysis-v6', 'technical-market-analysis-v7.2']
        return includedValues.includes(value)
    }, [assistant?.assistant, advance])

    if (!advance || !shouldRenderScenarios) return <></>

    const ScenarioComponent = scenarioRegistry[value]

    return (
        <>
            <ScenarioComponent data={advance} />
        </>
    )
}

export default ScenariosTab